import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { HUB_API_SETTINGS_TOKEN } from '../../hub-api-settings-token';
import { HubApiSettingsService } from '../../hub-api-settings.service';

import { CreateScaffoldDiaryMediaCommand } from '../model/command/create-scaffold-diary-media-command';
import { EditScaffoldMediaCommand } from '../model/command/edit-scaffold-media-command';
import { EditScaffoldMediaTranscriptionCommand } from '../model/command/edit-scaffold-media-transcription-command';
import { TranscribeMediaCommand } from '../model/command/transcribe-media-command';
import { CreateScaffoldWebConsoleCommand } from '../model/command/create-scaffold-web-console-command';
import { EditScaffoldWebConsoleCommand } from '../model/command/edit-scaffold-web-console-command';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

// Generated service for sending Scaffold commands to the API.
@Injectable()
export class ScaffoldCommandService {

  constructor(
    private http: HttpClient,
    private settingsService: HubApiSettingsService,
  ) { }

  CreateScaffoldDiaryMediaCommand(commandData: CreateScaffoldDiaryMediaCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Scaffold.CreateScaffoldDiaryMediaCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  EditScaffoldMediaCommand(commandData: EditScaffoldMediaCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Scaffold.EditScaffoldMediaCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  EditScaffoldMediaTranscriptionCommand(commandData: EditScaffoldMediaTranscriptionCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Scaffold.EditScaffoldMediaTranscriptionCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  TranscribeMediaCommand(commandData: TranscribeMediaCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Scaffold.TranscribeMediaCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  CreateScaffoldWebConsoleCommand(commandData: CreateScaffoldWebConsoleCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Scaffold.CreateScaffoldWebConsoleCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  EditScaffoldWebConsoleCommand(commandData: EditScaffoldWebConsoleCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Scaffold.EditScaffoldWebConsoleCommand'
      },
    };
    return this.http.request('POST', url, options);
  }
}
